import {
    animate,
    state,
    style,
    transition,
    trigger,
} from '@angular/animations';
import { Component, Signal, WritableSignal, computed, inject } from '@angular/core';
import { FlexComponent } from '../flex/flex.component';
import { IconComponent } from '../icon/icon.component';
import { ToastService } from '../../../services/components/toast.service';

@Component({
    selector: 'app-toast',
    standalone: true,
    imports: [IconComponent, FlexComponent],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss',
    animations: [
        trigger('slideUp', [
            state(
                'in',
                style({
                    opacity: 1,
                    transform: 'translateY(0px) translateX(-50%)',
                })
            ),
            transition('void => in', [
                animate(200),
                style({
                    opacity: 1,
                    transform: 'translateX(-50%) translateY(0px)',
                }),
            ]),
            transition('in => void', [
                animate(
                    200,
                    style({
                        opacity: 0,
                        transform: 'translateY(15px) translateX(-50%)',
                    })
                ),
            ]),
        ]),
    ],
})
export class ToastComponent {
    private toastService: ToastService = inject(ToastService);

    show: WritableSignal<boolean> = this.toastService.show;
    message: WritableSignal<string> = this.toastService.message;
    type: WritableSignal<string> = this.toastService.type;

    // Progress signals
    hasProgress: Signal<boolean> = this.toastService.hasProgress;
    progressPercentage: Signal<number> = this.toastService.progressPercentage;
    progressCurrent: WritableSignal<number> = this.toastService.progressCurrent;
    progressTotal: WritableSignal<number> = this.toastService.progressTotal;
    progressStep: WritableSignal<string> = this.toastService.progressStep;
    progressTitle: WritableSignal<string> = this.toastService.progressTitle;
    progressCompleted: WritableSignal<boolean> = this.toastService.progressCompleted;

    /** SVG circular progress: stroke-dasharray calculation (circumference = 2πr = 2π×18 ≈ 113.1) */
    circleDasharray: Signal<string> = computed(() => {
        const circumference = 113.1;
        const pct = this.progressPercentage();
        const filled = (pct / 100) * circumference;
        return `${filled} ${circumference - filled}`;
    });
}
